import { render, staticRenderFns } from "./Vehicles_New.vue?vue&type=template&id=6240ad67&scoped=true&"
import script from "./Vehicles_New.vue?vue&type=script&lang=js&"
export * from "./Vehicles_New.vue?vue&type=script&lang=js&"
import style0 from "./Vehicles_New.vue?vue&type=style&index=0&id=6240ad67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6240ad67",
  null
  
)

export default component.exports